module.exports = __webpack_public_path__ + "static/image007-99c7a3eeb5f06b59f7841d7392879ab7.jpg";